// Autogenerated file
export const classificationScopesEnum = {
    Single: "Single",
    Period: "Period",
};
export const classificationScopes = [
    { label: "Одиночная", value: "Single" },
    { label: "Сводная (за период)", value: "Period" },
];
